import { Avatar, Box, Checkbox, Chip, Divider, Fab, Grid, IconButton, Paper, Tab, TableRow, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import StatusBox from './StatusBox'
import { makeStyles } from 'tss-react/mui';
import CommonDataTable from './CommonDataTable';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchField from './SearchField';
import CommonTable from '../Common/CommonTable';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StyledTableCell from '../Common/styledTableCell';
import CustomPagination from '../Common/CommonPagination';
import { useDispatch } from 'react-redux';
import { showLoader } from '../../Redux/Slices/loaderSlice'
import { assignMember, get_all_followups, getAvailableAccess, getDocumentAssigneeRoles, getDocuments, getMembersSummary, update_followup } from '../../Redux/Actions/action';
import ErrorHandler, { capitalizeFirstLetterOfWords, checkAccess, CommonChip, CommonChipFollowUpStatus, formattedDate, getImageUrl, getLabelbyId, getValuebyId, } from '../../Utils/handler';
import { toast } from 'react-toastify';
import CommonSearchField from '../Common/CommonSearchField';
import { BucketURL } from '../../ApiSetup/Api';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DataNotFound from '../Common/DataNotFound';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { TabContext, TabList } from '@mui/lab';
import CustomDialog from '../Common/CustomDialog';
import ButtonContained from '../Common/ButtonContained';
import CommonTextField from '../Common/CommonTextField';
import EditIcon from '@mui/icons-material/Edit';
import CommonDropDown from '../Common/CommonDropDown';
import { followUpStatus, followUpStatusMemberRquest } from '../../Utils/enum';
import TextLabel from '../Common/CommonTextLabel';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import sessionStoreUtil from '../../ApiSetup/Localstorage';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import SearchIcon from '@mui/icons-material/Search';

const useStyles = makeStyles()((theme) => ({
}));

const DocumentsComonent = () => {
  // ---------- Hook -----------
  const { classes } = useStyles();
  const theme = useTheme()
  const dispatch = useDispatch()
  const sm = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const dataAccess = useSelector(value => value?.allAvailableAccess?.AllAvailableAccessList);
  const user = sessionStoreUtil.getLSItem('userData') ? JSON.parse(sessionStoreUtil.getLSItem('userData')) : {}

  // --------------- State -------------
  const [tab, setTab] = useState('1')
  const [tableData, setTableData] = useState({})
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(25); // Optimized: smaller default for faster loading
  const [searchText, setSearchText] = React.useState("");
  const [membersSummary, setMembersSummary] = useState();
  const [allFollowups, setAllFollowups] = useState();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [memberId, setMemberId] = useState({});
  const [followUpStatus, setFollowUpStatus] = useState({ followUpStatus: "", remark: "" });
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [assigneeRoleList, setAssigneeRoleList] = useState([]);
  const [isAssignedModal, setIsAssignedModal] = useState(false);
  const [data, setData] = useState({});
  const [sorting, setSorting] = useState({
    isPpskId: "",
    isSubmittedDate: "",
    isUpdatedDate: "",
    isRenewDays: "",
    isVerifyBy: ""
  });
  const [isSearch, setIsSearch] = useState(false);

  // --------------- handleChange ---------------
  const isSelected = (id) => selectedMembers?.indexOf(id) !== -1;

  const handelChangeFlolowUp = (e) => {
    const { name, value } = e.target;

    setFollowUpStatus({
      ...followUpStatus,
      [name]: value
    })
  }

  const handleClear = () => {
    setOpen(false);
    setFollowUpStatus({
      followUpStatus: "",
      remark: ""
    });
    setError("")
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const viewHandler = (item) => {
    navigate(`/admin/documents-view?id=${item._id}`);
    // setCandidate(item)
  }

  const handleClick = (event, id, status) => {
    // Prevent row click event from selecting the checkbox
    event.stopPropagation();
    if (status === 3 && status === 4) return;

    const selectedIndex = selectedMembers?.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedMembers, id);
    } else {
      newSelected = selectedMembers?.filter((item) => item !== id);
    }
    setSelectedMembers(newSelected);
  };

  const handleCheckboxClick = (event, id) => {
    event.stopPropagation();
    handleClick(event, id);
  };

  const handleClearAssigned = () => {
    setIsAssignedModal(false);
    setError({});
    setData({});
  };

  const _generateExcel = (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    const headerRowValues = [
      "No",
      "PPSK ID",
      "Name",
      "Contact No.",
      "Gender",
      "Submitted Date",
      "Updated Date",
      "Status",
      "Followup Status",
      "Assigned To",];
    const headerRow = worksheet.addRow(headerRowValues);

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '3e4094' } // Background color
      };
      cell.font = { bold: true, color: { argb: 'FFFFFF' } }; // White text, bold font
    });
    // Add data rows
    data?.forEach((document, index) => {
      worksheet.addRow([
        index + 1 || "-",
        document?.ppskId || "-",
        document?.fullName || "-",
        document?.phoneNumber || "-",
        document?.personalDetails?.gender || "-",
        dayjs(document?.createdAt).format("ll") || "-",
        dayjs(document?.updatedAt).format("ll") || "-",
        document?.verificationStatus || "-",
        document?.followUpStatus || "-",
        document?.assigneeName || "-",
      ]);
    });

    worksheet.columns = [{ width: 10 }, { width: 20 }, { width: 40 }, { width: 20 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 40 }];
    // Save workbook to file
    workbook.xlsx.writeBuffer().then(buffer => {
      const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(data, `${`Pending Members ${dayjs(new Date()).format('DD/MM/YYYY')}`}`);
    }).catch(err => {
      console.error("Error generating Excel:", err);
    });
  };

  // --------------- Api  ---------------
  const _downloadMembers = async () => {
    dispatch(showLoader(true))
    let body = {
      search: searchText || '',
      verificationStatus: 'Pending',
      isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
      isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
      isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
      isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
      isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : ""
    }
    try {
      const result = await dispatch(getDocuments(body));
      const error = ErrorHandler(result);
      if (error) {
        _generateExcel(result?.payload?.data?.members)
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  }

  const _getDocumetsData = async () => {
    dispatch(showLoader(true))
    let body = {
      search: searchText || '',
      page: page,
      limit: rowsPerPage,
      verificationStatus: 'Pending',
      status: "All",
      isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
      isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
      isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
      isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
      isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : ""
    }
    try {
      const result = await dispatch(getDocuments(body));
      const error = ErrorHandler(result);
      if (error) {
        // toast.success(result?.payload?.message);
        setTableData(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  }

  const _getSummaryDetails = async () => {
    dispatch(showLoader(true))
    let body = {}
    try {
      const result = await dispatch(getMembersSummary(body));
      const error = ErrorHandler(result);
      if (error) {
        setMembersSummary(result?.payload?.data?.counts)
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  }

  const getAllFollowups = async (id) => {
    dispatch(showLoader(true))
    let body = { id: id }
    try {
      const result = await dispatch(get_all_followups(body));
      const error = ErrorHandler(result);
      if (error) {
        setAllFollowups(result?.payload?.data?.followUps)
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  }

  const _addFollowups = async () => {
    if (!followUpStatus?.followUpStatus) {
      setError({ followUpStatus: "please select any one status" })
      return
    }
    dispatch(showLoader(true))
    try {
      let body = {
        "id": memberId,
        "currentStatus": followUpStatus?.followUpStatus,
        "remark": followUpStatus?.remark || ""
      }
      const result = await dispatch(update_followup(body))
      const error = ErrorHandler(result)
      if (error) {
        toast.success(result?.payload?.message);
        setFollowUpStatus({
          followUpStatus: "",
          remark: ""
        });
        setOpen(false);
        setError({});
        _getDocumetsData();
      }
    } catch (error) {
      toast.error(error?.message || "An unknown error occurred");
    } finally {
      dispatch(showLoader(false))
    }
  }

  const _getDocumentAssigneeRoles = async () => {
    dispatch(showLoader(true))
    try {
      let body = {}
      const result = await dispatch(getDocumentAssigneeRoles(body));
      const error = ErrorHandler(result);
      if (error) {
        setAssigneeRoleList(result?.payload.data.response)
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  }

  const _assignMember = async () => {

    if (!data?.member) {
      setError({ member: "please select any one member" })
      return
    }
    dispatch(showLoader(true))
    try {
      let body = {
        "assignedTo": assigneeRoleList?.find((val) => val?.fullName === data?.member)?._id,
        "assignedIds": selectedMembers
      }
      const result = await dispatch(assignMember(body))
      const error = ErrorHandler(result)
      if (error) {
        toast.success(result?.payload?.message);
        setSelectedMembers([])
        setIsAssignedModal(false);
        setData({});
        setError({});
        _getDocumetsData();
      }
    } catch (error) {
      toast.error(error?.message || "An unknown error occurred");
    } finally {
      dispatch(showLoader(false))
    }
  }

  // ----------- useEffect -----------
  // OPTIMIZED: Combine initial data fetching to reduce render cycles
  useEffect(() => {
    const loadInitialData = async () => {
      dispatch(showLoader(true));
      try {
        // Load all initial data in parallel
        await Promise.all([
          dispatch(getAvailableAccess()).unwrap().catch(() => {}),
          _getSummaryDetails(),
          _getDocumentAssigneeRoles()
        ]);
      } catch (error) {
        console.error("Error loading initial data:", error);
      } finally {
        dispatch(showLoader(false));
      }
    };
    loadInitialData();
  }, []);

  // Separate effect for data that changes with pagination/search/sorting
  useEffect(() => {
    _getDocumetsData();
  }, [page, rowsPerPage, searchText, sorting])

  const tableHeaders = [
    ...(checkAccess(pathname, dataAccess, 'Assign Member')
      ? [
        <Checkbox
          key="select-all-checkbox"
          color="success"
          indeterminate={selectedMembers.length > 0 && selectedMembers.length < tableData?.members?.length}
          checked={tableData?.members?.length > 0 && selectedMembers?.length === tableData?.members?.length}
          onChange={(event) => {
            const newSelected = event.target.checked
              ? tableData?.members?.map((item) => item._id)
              : [];
            setSelectedMembers(newSelected);
          }}
          sx={{ '& .MuiSvgIcon-root': { color: "#ffffff" } }}
        />
      ]
      : []),  // If condition is false, no checkbox is added
    "No",
    "Photo",
    "PPSK ID",
    "Name",
    "Mobile No",
    "Gender",
    "Submitted Date",
    "Updated Date",
    "Status",
    "Followup Status",
    !(user?.loginRole === "Verifier" || user?.loginRole === "SeniorStaff") && "Assigned To",
    (checkAccess(pathname, dataAccess, 'Action View') || checkAccess(pathname, dataAccess, 'Action Edit')) && "View Docs"
  ].filter(Boolean);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={12}>
        <Paper elevation={0} sx={{ padding: 2, background: { md: "#fff", xs: "none" }, borderRadius: '20px', border: `1px solid lightgrey` }}>
          <Box display={"flex"} justifyContent={"end"} alignItems={{ sm: "center", xs: "start" }} mb={1} gap={1} flexDirection={{ sm: "row", xs: "column" }}>
            {!isSearch ? (
              <Tooltip title="Search">
                <Fab sx={{
                  width: '46px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, border: '1px solid rgba(34, 34, 34, 0.3)', borderRadius: '10px', backgroundColor: "transparent", color: "rgba(34, 34, 34, 0.3)",
                }} onClick={() => setIsSearch(true)}>
                  <SearchIcon sx={{ fontSize: '24px' }} />
                </Fab>
              </Tooltip>
            ) : (
              <CommonSearchField placeholder={"Search.."} tooltipList={['Name', "Mobile Number", "PPSK ID"]} handleSearch={(e) => { setPage(1); setSearchText(e); }} />
            )}
            {(checkAccess(pathname, dataAccess, 'Assign Member')) &&
              <ButtonContained
                text={"Assigne Selected Member"}
                fontSize={{ xs: "13px", md: "14px" }}
                height={"40px"}
                onClick={() => setIsAssignedModal(true)}
                disabled={selectedMembers.length > 0 ? false : true}
              />}
            <Tooltip title={"Download Pending Member"}>
              <Fab disabled={tableData?.members?.length === 0} color='primary' sx={{
                width: '56px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, borderRadius: '10px',
              }} onClick={() => _downloadMembers()}>
                <FileDownloadOutlinedIcon sx={{ fontSize: '24px' }} />
              </Fab>
            </Tooltip>
          </Box>

          <CommonTable headerList={tableHeaders} align={'center'} minWidth={600} setSorting={setSorting} sorting={sorting}>
            {tableData?.members?.length > 0 ? tableData?.members?.map((document, index) => {
              let image = document?.personalDetails?.image ? getImageUrl(document?.personalDetails?.image) : "No";
              const isItemSelected = isSelected(document?._id);
              return (
                <TableRow key={index}>
                  {(checkAccess(pathname, dataAccess, 'Assign Member')) ? <StyledTableCell align="center">
                    <Checkbox
                      color="primary"
                      checked={isItemSelected}
                      onChange={(event) => handleCheckboxClick(event, document?._id)}
                      sx={{ '& .MuiSvgIcon-root': { color: "#666666", }, }}
                    />
                  </StyledTableCell> : ""}
                  <StyledTableCell align="center">{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>
                  <StyledTableCell align="center" >
                    <Box display={'flex'} justifyContent={'center'}>
                      <Avatar src={image} slotProps={{ img: { loading: 'lazy', } }} sx={{ borderRadius: '6px' }} />
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="center">{document?.ppskId || "-"}</StyledTableCell>
                  <StyledTableCell align="center">{document?.personalDetails?.firstName && document?.personalDetails?.middleName && document?.personalDetails?.lastName ? capitalizeFirstLetterOfWords(document?.personalDetails?.firstName + " " + document?.personalDetails?.middleName + " " + document?.personalDetails?.lastName) : document?.personalDetails?.fullName ? document?.personalDetails?.fullName : "-"}</StyledTableCell>
                  <StyledTableCell align="center">{document?.phoneNumber ? document?.phoneNumber : document?.personalDetails?.phoneNumber ? document?.personalDetails?.phoneNumber : "-"}</StyledTableCell>
                  <StyledTableCell align="center" sx={{ textTransform: 'capitalize' }}>{capitalizeFirstLetterOfWords(document?.personalDetails?.gender || "-")}</StyledTableCell>
                  <StyledTableCell align="center">{dayjs(document?.createdAt).format("ll") || "-"}</StyledTableCell>
                  <StyledTableCell align="center">{dayjs(document?.updatedAt).format("ll") || "-"}</StyledTableCell>
                  <StyledTableCell align="center">
                    <CommonChip label={document?.verificationStatus} status={document?.verificationStatus} />
                  </StyledTableCell>
                  <StyledTableCell align="center" onClick={() => { setOpen(true); setMemberId(document?._id); getAllFollowups(document?._id) }}>
                    <Box sx={{ cursor: "pointer", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Tooltip title={document?.followUpStatus}>
                        <Box width={"100px"} textAlign={"center"} sx={{ cursor: "pointer" }}>
                          <CommonChipFollowUpStatus fontSize={"13px"} height={"28px"} label={document?.followUpStatus} />
                        </Box>
                      </Tooltip>
                    </Box>
                  </StyledTableCell>
                  {!(user?.loginRole === "Verifier" || user?.loginRole === "SeniorStaff") && <StyledTableCell align="center">{document?.assigneeName || "-"}</StyledTableCell>}
                  {
                    (checkAccess(pathname, dataAccess, 'Action View') || checkAccess(pathname, dataAccess, 'Action Edit')) && <StyledTableCell align="center">
                      <IconButton sx={{
                        padding: 0.5, "&:hover": {
                          border: "1px solid rgba(62, 64, 149, 1)",
                          background: "rgba(215, 223, 255, 1)",
                          borderRadius: "10px"
                        }
                      }} onClick={() => viewHandler(document)}>
                        <VisibilityIcon fontSize='medium' color='primary' />
                      </IconButton>
                    </StyledTableCell>
                  }
                </TableRow>
              )
            }) :
              (
                <TableRow>
                  <StyledTableCell colSpan={13}>
                    <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                  </StyledTableCell>
                </TableRow>
              )
            }

          </CommonTable>

          {tableData?.count > 0 &&
            <Grid item xs={12}>
              <CustomPagination
                rowsPerPageOptions={[10, 25, 50]}
                count={Math.ceil(tableData?.count / rowsPerPage)}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage} />

            </Grid>
          }
        </Paper>
      </Grid>

      {open && <CustomDialog
        isOpen={open} handleClose={handleClear} title={'Follow up'} padding={'10px'}
        maxWidth={"sm"}
        action={
          <>
            <ButtonContained
              text={'Update'}
              onClick={() => _addFollowups()}
              minWidth={'auto'}
              marginTop={'10px'}

            />
          </>
        }
      >

        <Grid container xs={12} spacing={1}>

          <Grid item xs={12}>
            {allFollowups?.length > 0 &&
              allFollowups?.map((data, i) => {
                const formattedDate = new Intl.DateTimeFormat("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }).format(new Date(data?.createdAt));
                return (
                  <>
                    <Grid container key={data?._id} alignItems="center" my={1} >
                      {/* Status Button */}
                      <Grid item xs={12} textAlign={"center"} sx={{ border: "1px dashed blue", borderRadius: "5px", padding: "5px" }}>
                        <Box display={"flex"} justifyContent={"space-between"} >

                          <Box display={"flex"} flexDirection={"column"} alignItems={"start"} gap={"5px"}>
                            <Box display={"flex"} alignItems={"center"} gap={0.5}>
                              <Typography color={"#3e4095"} fontSize={"12px"}>Status : </Typography>
                              <Typography variant="body1">
                                {<CommonChipFollowUpStatus label={data?.currentStatus} />}
                              </Typography>
                            </Box>

                            <Box display={"flex"} alignItems={"center"} gap={0.5}>
                              <Typography color={"#3e4095"} fontSize={"12px"}>Date :</Typography>
                              <Typography variant="body2"> {formattedDate} </Typography>
                            </Box>
                          </Box>

                          <Box display={"flex"} flexDirection={"column"} alignItems={"start"} gap={"5px"}>
                            <Box display={"flex"} alignItems={"center"} gap={0.5}>
                              <Typography color={"#3e4095"} fontSize={"12px"}>Verify By :</Typography>
                              <Typography variant="body2"> {data?.changedBy} </Typography>
                            </Box>

                            <Box display={"flex"} alignItems={"center"} gap={0.5}>
                              <Typography color={"#3e4095"} fontSize={"12px"}>Remark :</Typography>
                              <Tooltip title={data?.remark}>
                                <Box width={"120px"} textAlign={"start"} sx={{ cursor: "pointer" }}>
                                  <Typography variant="body2" noWrap>
                                    {data?.remark || "-"}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Box>
                          </Box>

                        </Box>

                      </Grid>
                    </Grid>
                  </>
                )
              })}
          </Grid>

          <Grid item xs={12}>
            <CommonDropDown
              type="text"
              text={'FollowUp Status'}
              name={'followUpStatus'}
              value={followUpStatus?.followUpStatus}
              values={followUpStatusMemberRquest?.map((e) => e?.label) || []}
              placeholder={`Select Id Proof`}
              width={"100%"}
              valid
              onChange={handelChangeFlolowUp}
            />
            <TextLabel color="error" title={!followUpStatus?.followUpStatus ? error?.followUpStatus : ""} />
          </Grid>
          <Grid item xs={12} >
            <CommonTextField
              value={followUpStatus?.remark}
              text="Remark"
              type="text"
              onChange={handelChangeFlolowUp}
              labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
              labelColor={theme?.palette?.primary?.main}
              height={30}
              name="remark"
              rows={3}
              multiline={3}
            />
          </Grid>
        </Grid>
      </CustomDialog>
      }

      {isAssignedModal && <CustomDialog
        isOpen={isAssignedModal} handleClose={handleClearAssigned} title={"Assigne Selected Member"} padding={'10px'}
        width={400}
        action={
          <>
            <ButtonContained
              text={"Submit"}
              onClick={_assignMember}
              minWidth={'100%'}
              marginTop={'10px'}
            />
          </>
        }
      >
        <Grid container spacing={2} xs={12}>
          <Grid item xs={12}>
            <CommonDropDown
              type="text"
              text={'Select Assignee'}
              labelColor={theme.palette.primary.main}
              name={'member'}
              value={data?.member || ""}
              values={assigneeRoleList?.map((e) => e?.fullName) || []}
              placeholder={`Select member`}
              width={"100%"}
              valid
              onChange={(e) => {
                const { value } = e?.target
                setData((prevValue) => ({
                  ...prevValue,
                  member: value,
                }));
              }}
            />
            <TextLabel color="error" title={!data?.member ? error?.member : ""} />
          </Grid>
        </Grid>
      </CustomDialog>}

    </Grid>
  )
}

export default DocumentsComonent
